module.exports = __webpack_public_path__ + "img/1513078498.a54e5882.jpg";